<template>
    <modal id="order-reject-modal"
           v-model="showModal"
           :title="$t('reject_oder_label')"
           :preloader="preloader"
           @submit="saveStatus"
           :loading="loading"
    >
        <app-form-group
                :label="$t('note')"
                type="textarea"
                v-model="formData.note"
                :placeholder="$placeholder('note')"
                :error-message="$errorMessage(errors, 'note')"
                :text-area-rows="5"
        />
    </modal>
</template>

<script>
    import ModalMixin from "../../../Mixins/ModalMixin";
    import {axiosPatch} from "../../../Helpers/AxiosHelper";
    import {ORDERS} from "../../../Config/ApiUrl";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";

    export default {
        mixins: [ModalMixin, FormHelperMixin],
        name: "OrderRejectModal",
        props: {
            order: {}
        },
        data() {
            return {
                formData: {}
            }
        },
        methods: {
            saveStatus() {
                axiosPatch(`/${ORDERS}/${this.order}/reject`, this.formData)
                    .then(response => {
                        this.toastAndReload(response.data.message, 'orders-table');
                        $("#order-reject-modal").modal('hide')
                    })
                    .catch(({response}) => {
                        this.afterError(response);
                    })
            }
        },
    }
</script>

<style scoped>

</style>